(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/utils/validate-ticket.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/utils/validate-ticket.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const formatTicketId = svs.ticketgames.ticketMappings.productMappings.formatTicketId;
const NO_WIN = 'NO_WIN';
const WIN = 'WIN';
const HIGH_WIN_NO_PAYOUT = 'HIGH_WIN_NO_PAYOUT';
const MEDIUM_WIN = 'MEDIUM_WIN';
const WIN_NON_FIXED_PRIZE = 'WIN_NON_FIXED_PRIZE';
const HIGH_WIN_INTERNAL = 'HIGH_WIN_INTERNAL';
const WIN_FREE_TICKET = 'WIN_FREE_TICKET';
const PAYOUT_ON_HOLD = 'PAYOUT_ON_HOLD';

const ALREADY_CLAIMED_AT_THIS_RETAILER = 'ALREADY_CLAIMED_AT_THIS_RETAILER';
const ALREADY_CLAIMED_ONLINE = 'ALREADY_CLAIMED_ONLINE';
const ALREADY_CLAIMED_AT_OTHER_RETAILER = 'ALREADY_CLAIMED_AT_OTHER_RETAILER';
const ALREADY_PAID_ONLINE = 'ALREADY_PAID_ONLINE';
const ALREADY_PAID_BY_THIS_RETAILER = 'ALREADY_PAID_BY_THIS_RETAILER';
const ALREADY_PAID_AFTER_CLOSING = 'ALREADY_PAID_AFTER_CLOSING';
const ALREADY_PAID_BY_OTHER_RETAILER = 'ALREADY_PAID_BY_OTHER_RETAILER';
const ALREADY_CLAIMED_BY_OTHER_CUSTOMER = 'ALREADY_CLAIMED_BY_OTHER_CUSTOMER';
const ALREADY_CLAIMED_BY_OTHER_CUSTOMER_ERROR_CODE = 12312; 
const SPELPAUS_ERROR_CODES = [5135, 1019, 135];
const SERVICE_BLOCKED_ERROR_CODE = 13144;
const VALIDATION_PERIOD_ERROR = 'VALIDATION_PERIOD_ERROR';
const WRONG_BUNDLE_STATE = 'WRONG_BUNDLE_STATE';
const UNKNOWN_CYCLE = 'UNKNOWN_CYCLE';
const BUNDLE_STOLEN = 'BUNDLE_STOLEN';
const CHECKSUM_ERROR = 'CHECKSUM_ERROR';
const NON_FIXED_DATA_MISSING = 'NON_FIXED_DATA_MISSING';
const ERROR = 'ERROR';
const CUSTBLOCKED_TOO_MANY_ERRORS = 'CUSTBLOCKED_TOO_MANY_ERRORS';
const CUSTBLOCKED_TOO_MANY_VALIDATIONS = 'CUSTBLOCKED_TOO_MANY_VALIDATIONS';
const contactCustomerService = "Kontakta <a href=\"".concat(svs.core.urlMapping.get('customerServiceContact'), "\">Kundservice</a>. Telefon 0770-11 11 11.");
const isManualMode = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isManual = queryParams.get('manual') === 'true';
  if (isManual) {
    svs.ticketsValidate.logger.info('Manual code input mode detected');
  }
  return isManual;
};
const messages = {
  error: {
    CHECKSUM_ERROR: {
      title: 'Du har angett en felaktig kod',
      message: 'Kontrollera att du skrivit in rätt kod och försök igen.'
    },
    CHECKSUM_ERROR_MANUAL: {
      title: 'Fel kod, testa igen!',
      message: 'Kontrollera den 27-siffriga koden på lottens baksida samt den 4-siffriga koden i kontrollrutan och försök igen.'
    },
    WRONG_CODE: {
      title: 'Du har angett en felaktig kod',
      message: 'Kontrollera att du skrivit in rätt kod och försök igen.'
    },
    CUSTBLOCKED_TOO_MANY_VALIDATIONS: {
      title: 'Du har rättat för många lotter',
      message: 'Av säkerhetsskäl kommer tjänsten för att rätta lott att spärras i 24 timmar.'
    },
    CUSTBLOCKED_TOO_MANY_ERRORS: {
      title: 'Du har angett en felaktig kod för många gånger',
      message: 'Av säkerhetsskäl kommer tjänsten för att rätta lott att spärras i 24 timmar.'
    },
    VALIDATION_PERIOD_ERROR: {
      title: 'Lottens giltighetstid har löpt ut.'
    },
    ALREADY_CLAIMED_OR_PAID: {
      title: 'Lotten är redan rättad',
      message: 'Du hittar dina rättade lotter i Mina spel.'
    },
    ALREADY_CLAIMED_OR_PAID_AT_OTHER_RETAILER: {
      title: 'Lottens vinst är redan utbetald hos ett ombud'
    },
    ALREADY_CLAIMED_BY_OTHER_CUSTOMER: {
      title: 'Lotten är redan rättad',
      message: 'Lotten är redan rättad av en annan kund.'
    },
    BUNDLE_STOLEN: {
      title: 'Lotten går inte att rätta',
      message: contactCustomerService
    },
    UNKNOWN_CYCLE: {
      title: 'Lotten går inte att rätta',
      message: contactCustomerService
    },
    WRONG_BUNDLE_STATE: {
      title: 'Lotten går inte att rätta'
    },
    DEFAULT: {
      title: 'Lotten går inte att rätta',
      message: contactCustomerService
    },
    SPELPAUS_ERROR: {
      title: 'Spelpaus',
      message: 'Du har en spelpaus aktiv. Kontakta kundservice för information om hur du kan rätta din lott.'
    }
  }
};
const getErrorCode = error => {
  let errorCode;
  if (typeof error === 'object') {
    svs.tur.apierrors.logger.warn('API Error', error);
    errorCode = parseInt(String(error === null || error === void 0 ? void 0 : error.code).replace(/\s/g, ''), 10);
  } else if (typeof error === 'number' || typeof error === 'string') {
    errorCode = parseInt(String(error).replace(/\s/g, ''), 10);
  }
  return errorCode;
};
const hasErrorResultCode = resultCode => {
  let messageError;
  const error = messages.error;
  switch (resultCode) {
    case VALIDATION_PERIOD_ERROR:
      messageError = error.VALIDATION_PERIOD_ERROR;
      break;
    case ALREADY_CLAIMED_BY_OTHER_CUSTOMER:
      messageError = error.ALREADY_CLAIMED_BY_OTHER_CUSTOMER;
      break;
    case ALREADY_CLAIMED_AT_OTHER_RETAILER:
    case ALREADY_PAID_BY_OTHER_RETAILER:
      messageError = error.ALREADY_CLAIMED_OR_PAID_AT_OTHER_RETAILER;
      break;
    case ALREADY_CLAIMED_AT_THIS_RETAILER:
    case ALREADY_CLAIMED_ONLINE:
    case ALREADY_PAID_ONLINE:
    case ALREADY_PAID_BY_THIS_RETAILER:
    case ALREADY_PAID_AFTER_CLOSING:
      messageError = error.ALREADY_CLAIMED_OR_PAID;
      break;
    case CUSTBLOCKED_TOO_MANY_ERRORS:
      messageError = error.CUSTBLOCKED_TOO_MANY_ERRORS;
      break;
    case CUSTBLOCKED_TOO_MANY_VALIDATIONS:
      messageError = error.CUSTBLOCKED_TOO_MANY_VALIDATIONS;
      break;
    case UNKNOWN_CYCLE:
      messageError = error.UNKNOWN_CYCLE;
      break;
    case BUNDLE_STOLEN:
      messageError = error.BUNDLE_STOLEN;
      break;
    case ERROR:
      messageError = error.WRONG_CODE;
      break;
    case CHECKSUM_ERROR:
      {
        const isManual = isManualMode();
        if (isManual) {
          svs.ticketsValidate.logger.info('Validation error with manual=true, showing error message for manual mode');
        }
        messageError = isManual ? error.CHECKSUM_ERROR_MANUAL : error.CHECKSUM_ERROR;
        break;
      }
    case WRONG_BUNDLE_STATE:
      messageError = error.WRONG_BUNDLE_STATE;
      break;
    case NON_FIXED_DATA_MISSING:
      messageError = error.DEFAULT;
      break;
    default:
      break;
  }
  if (!messageError) {
    return;
  }
  return {
    errorMessage: messageError.message || '',
    errorTitle: messageError.title,
    resultCode
  };
};
const getValidatedTicket = async _ref => {
  let ticketId = _ref.ticketId;
  const ticketNumber = formatTicketId(ticketId);
  const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.getPlayerValidatedTicket({
      ticketNumber
    }),
    response = _await$svs$tur$apiCal.response;
  return response;
};
const checkAlreadyClaimedByOtherCustomer = async _ref2 => {
  let ticketId = _ref2.ticketId;
  try {
    await getValidatedTicket({
      ticketId
    });
  } catch (error) {
    var _error$responseJson;
    const errorCode = (error === null || error === void 0 ? void 0 : error.code) || parseInt(error === null || error === void 0 || (_error$responseJson = error.responseJson) === null || _error$responseJson === void 0 ? void 0 : _error$responseJson.errorCode, 10);
    if (errorCode === ALREADY_CLAIMED_BY_OTHER_CUSTOMER_ERROR_CODE) {
      return ALREADY_CLAIMED_BY_OTHER_CUSTOMER;
    }
  }
};
const handleValidateTicketResponse = async (response, ticketId) => {
  let resultCode = response === null || response === void 0 ? void 0 : response.result;
  if (resultCode === NO_WIN) {
    resultCode = (await checkAlreadyClaimedByOtherCustomer({
      ticketId
    })) || resultCode;
  }
  const error = hasErrorResultCode(resultCode);
  if (error) {
    throw error;
  }
  switch (resultCode) {
    case WIN:
    case NO_WIN:
    case HIGH_WIN_NO_PAYOUT:
    case MEDIUM_WIN:
    case WIN_NON_FIXED_PRIZE:
    case HIGH_WIN_INTERNAL:
    case WIN_FREE_TICKET:
    case PAYOUT_ON_HOLD:
      break;
    default:
      svs.ticketsValidate.logger.warn("Unknown resultCode: ".concat(resultCode, " for ticketId: ").concat(ticketId));
      break;
  }
  return _objectSpread(_objectSpread({}, response), {}, {
    winAmount: parseInt(response === null || response === void 0 ? void 0 : response.winAmount, 10)
  });
};
const validateTicket = async _ref3 => {
  let ticketId = _ref3.ticketId,
    code = _ref3.code;
  const ticketNumber = ticketId.replaceAll('-', '').concat(code);
  const _await$svs$tur$apiCal2 = await svs.tur.apiCaller.ticketgames.postPlayerValidateTicket({
      data: {
        ticketNumber
      }
    }),
    response = _await$svs$tur$apiCal2.response;
  return handleValidateTicketResponse(response, ticketId);
};
const showErrorDialog = async function (error) {
  let cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => ({});
  let errorObj;
  if (error !== null && error !== void 0 && error.errorMessage || error !== null && error !== void 0 && error.errorTitle) {
    errorObj = error;
  } else {
    const errorCode = getErrorCode(error);
    if (SPELPAUS_ERROR_CODES.includes(errorCode)) {
      const _messages$error$SPELP = messages.error.SPELPAUS_ERROR,
        errorMessage = _messages$error$SPELP.message,
        errorTitle = _messages$error$SPELP.title;
      errorObj = {
        errorTitle,
        errorMessage
      };
    } else if (errorCode === SERVICE_BLOCKED_ERROR_CODE) {
      const _messages$error$CUSTB = messages.error.CUSTBLOCKED_TOO_MANY_ERRORS,
        errorMessage = _messages$error$CUSTB.message,
        errorTitle = _messages$error$CUSTB.title;
      errorObj = {
        errorTitle,
        errorMessage,
        resultCode: CUSTBLOCKED_TOO_MANY_ERRORS
      };
    } else {
      errorObj = await svs.tur.apierrors.getErrorMessage({
        error
      }, 'Tekniskt fel', 'Ett oväntat fel har inträffat.');
    }
    errorObj = _objectSpread(_objectSpread({}, errorObj), {}, {
      errorCode
    });
  }
  const _errorObj = errorObj,
    errorMessage = _errorObj.errorMessage,
    errorTitle = _errorObj.errorTitle;
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    type: svs.components.dialog.type.ERROR,
    title: errorTitle,
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: errorMessage
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        cb(errorObj);
        svs.components.dialog.api.close();
      }
    }]
  }));
};
const redirectByResultCode = async function (resultCode) {
  let branding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'triss';
  let ticketId = arguments.length > 2 ? arguments[2] : undefined;
  switch (resultCode) {
    case VALIDATION_PERIOD_ERROR:
    case ALREADY_CLAIMED_BY_OTHER_CUSTOMER:
    case ALREADY_CLAIMED_AT_OTHER_RETAILER:
    case ALREADY_PAID_BY_OTHER_RETAILER:
    case ALREADY_CLAIMED_AT_THIS_RETAILER:
    case ALREADY_CLAIMED_ONLINE:
    case ALREADY_PAID_ONLINE:
    case ALREADY_PAID_BY_THIS_RETAILER:
    case ALREADY_PAID_AFTER_CLOSING:
    case BUNDLE_STOLEN:
    case ERROR:
    case WRONG_BUNDLE_STATE:
    case NON_FIXED_DATA_MISSING:
      svs.utils.url.navigate(svs.core.urlMapping.get('ticketsValidateManual'));
      break;
    case CUSTBLOCKED_TOO_MANY_ERRORS:
    case CUSTBLOCKED_TOO_MANY_VALIDATIONS:
    case SERVICE_BLOCKED_ERROR_CODE:
      if (branding === 'skrapspel') {
        svs.utils.url.navigate(svs.core.urlMapping.get('skrapspelHome'));
      } else {
        svs.utils.url.navigate(svs.core.urlMapping.get('trissHome'));
      }
      break;
    case UNKNOWN_CYCLE:
    case CHECKSUM_ERROR:
      {
        const isManual = isManualMode();
        if (isManual) {
          var _svs$core$urlMapping$;
          svs.ticketsValidate.logger.info('User is in manual mode, redirecting to ticketsValidateManualCode');
          const ticketNumber = formatTicketId(ticketId);
          svs.utils.url.navigate((_svs$core$urlMapping$ = svs.core.urlMapping.get('ticketsValidateManualCode')) === null || _svs$core$urlMapping$ === void 0 ? void 0 : _svs$core$urlMapping$.replace(':ticketId', ticketNumber));
        } else {
          svs.ticketsValidate.logger.info('manual=true not found in URL or ticketId missing, staying on the page.');
        }
        break;
      }
    default:
  }
};
const redirectByError = (_ref4, branding, ticketId) => {
  let resultCode = _ref4.resultCode,
    errorCode = _ref4.errorCode;
  if (errorCode || errorCode === 0) {
    var _svs$core$urlMapping$2;
    svs.utils.url.navigate((_svs$core$urlMapping$2 = svs.core.urlMapping.get('ticketValidateHome')) === null || _svs$core$urlMapping$2 === void 0 ? void 0 : _svs$core$urlMapping$2.replace(':branding', branding));
  } else if (resultCode) {
    redirectByResultCode(resultCode, branding, ticketId);
  }
};
setGlobal('svs.ticketsValidate.utils', {
  validateTicket,
  showErrorDialog,
  redirectByError,
  messages,
  resultCodes: {
    NO_WIN,
    WIN,
    HIGH_WIN_NO_PAYOUT,
    MEDIUM_WIN,
    WIN_NON_FIXED_PRIZE,
    HIGH_WIN_INTERNAL,
    WIN_FREE_TICKET,
    PAYOUT_ON_HOLD,
    ALREADY_CLAIMED_AT_THIS_RETAILER,
    ALREADY_CLAIMED_ONLINE,
    ALREADY_CLAIMED_AT_OTHER_RETAILER,
    ALREADY_CLAIMED_BY_OTHER_CUSTOMER,
    ALREADY_PAID_ONLINE,
    ALREADY_PAID_BY_THIS_RETAILER,
    ALREADY_PAID_AFTER_CLOSING,
    ALREADY_PAID_BY_OTHER_RETAILER,
    VALIDATION_PERIOD_ERROR,
    WRONG_BUNDLE_STATE,
    UNKNOWN_CYCLE,
    BUNDLE_STOLEN,
    CHECKSUM_ERROR,
    NON_FIXED_DATA_MISSING,
    ERROR,
    CUSTBLOCKED_TOO_MANY_ERRORS,
    CUSTBLOCKED_TOO_MANY_VALIDATIONS
  },
  ALREADY_CLAIMED_BY_OTHER_CUSTOMER_ERROR_CODE
});

 })(window);